import { render, staticRenderFns } from "./AutoBots.vue?vue&type=template&id=5717c006&scoped=true&"
import script from "./AutoBots.vue?vue&type=script&lang=js&"
export * from "./AutoBots.vue?vue&type=script&lang=js&"
import style0 from "./AutoBots.vue?vue&type=style&index=0&id=5717c006&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5717c006",
  null
  
)

export default component.exports